<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 font_regular">Manpower Plan vs Actual</p>
         </div>
         <div class="popup-close">
          <button class="download-btn" (click)="downloadExcel(getManpowerPlanvsActualData)">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
 
    </ion-col>
  </ion-row>
  
  <ion-row>
    <ion-col size="12">
      <div class="table-container">
      <table class="Market-correction-employees-table">
        <thead>
          <tr>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Department
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Band 
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Plan (Active +vacant) -A
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Actual (active in employee Master)-B
              </div>
            </th>
            <th class="fs-14 font_bold cl-black">
              <div class="icon-style">
                Gap (A-B)
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let department of getManpowerPlanvsActualData">
            <ng-container *ngFor="let band of department.bands; let i = index">
                <tr>
                  <td *ngIf="i === 0" [attr.rowspan]="department.bands.length">
                   {{department.department}}
                  </td>
                  <td >
                    {{band.band}}
                  </td>
                  <td>{{band.plan}}</td>
                  <td>{{band.actual}}</td>
                  <td>{{band.gap}}</td>
                </tr>
            </ng-container>
          </ng-container>
       </tbody>
      </table>
      </div>
    </ion-col>
  </ion-row>
</div>